export default "__VITE_ASSET__BbQOWZzG__"